import React from 'react'
import "./footernav.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGift,faHome, faUser, faPen } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import Review from "./review"
const Footernav = () => {
  const [openr, seTr] = useState(false);
   const [opene, seTe] = useState(false);
   const Sle=()=>{
    alert("Comming Soon !");
   }
  return (
    <section className='sticky-bott'>
    <div className="bookin-btn">
                <div className="sticky-contain active">
                  <FontAwesomeIcon icon={faHome}></FontAwesomeIcon>
                  <p className="sticky-contain-p active">Home</p>
                </div>
                 <div className="sticky-contain" onClick={() => seTe(true)}>
                  <FontAwesomeIcon icon={faGift}></FontAwesomeIcon>
                  <p className="sticky-contain-p">Offer</p>
                </div>
               <div className="sticky-contain" onClick={() => seTr(true)}>
               <FontAwesomeIcon icon={faPen}></FontAwesomeIcon>
                  <p className="sticky-contain-p">Review</p>
                </div>
                <div className="sticky-contain"onClick={()=>Sle()}>
                  <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
                  <p className="sticky-contain-p">Listing</p>
                </div>
   </div>
  {openr &&( 
  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Link to="/reviews"className="see-re">See Reviews Given By Previous Travellers</Link>
<Review /></section>
  
)}
 {opene &&( 
  <section className="bookings">

<p className="fvb">No Offer Right Now. see our Nepal Tour packages</p>
<div className='dfcv'><Link to="/nepal-tour" className='fhj'>Nepal Tour</Link></div>
</section>
 
)}
    </section>
  )
}

export default Footernav